import type { ScanPhotoSource } from '@kaiizen/kai-scan-template-system';

export type FocusedPhotoStripEntry = {
  photoId: string;
  scope: 'task' | 'group';
  addedAt?: string | number;
  addedByUserId?: string;
  photoSource?: ScanPhotoSource;
  taskLabel?: string;
  groupLabel?: string;
  dateLabel?: string;
  walkLabel?: string;
  groupId?: string;
  taskId?: string;
};

export const GROUP_PHOTO_CHIP_LABEL = 'Group';
export const SCOPE_VIDEO_CHIP_LABEL = 'Scope';

/** Combined photo + video tile budget for the horizontal strip. */
export const FOCUSED_STRIP_MAX_TILES = 100;
/** @deprecated Use `FOCUSED_STRIP_MAX_TILES`. */
export const FOCUSED_PHOTO_STRIP_MAX_PHOTOS = FOCUSED_STRIP_MAX_TILES;

export const MORE_PHOTOS_TILE_LABEL = 'View all';
export const TASK_PHOTO_CHIP_LABEL_FALLBACK = 'Task';
export const NON_STANDARD_TASK_CHIP_LABEL_PREFIX = 'NST: ';
export const ADD_MEDIA_LABEL = 'Add photos';
export const VIEW_ALL_AND_MANAGE_LABEL = 'View all & manage';

export const PHOTO_CHIP_LABEL_MAX_LENGTH = 18;

export type FocusedStripCountMode = 'photos-only' | 'media';
